"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindBankSmsRequest = void 0;
var bindBankSmsRequest = /** @class */ (function () {
    function bindBankSmsRequest() {
        // 身份证
        this.idNo = '';
        // 名字
        this.custName = '';
        // 预留手机号
        this.reservedMobile = '';
        // 银行卡号
        this.bankCardNum = '';
    }
    return bindBankSmsRequest;
}());
exports.bindBankSmsRequest = bindBankSmsRequest;
;
//# sourceMappingURL=bindBankSms.request.js.map